import { createFileRoute } from "@tanstack/react-router";
import Avisos from "@/pages/admin/Avisos";
import { pageHead } from "@/lib/seo";

// Avisos: as notificações no celular da Clara (ligar, escolher os tipos, testar) e os recados para as pacientes.
export const Route = createFileRoute("/admin/avisos")({
  head: () => pageHead({ title: "Avisos | Painel", path: "/admin/avisos", noindex: true }),
  component: Avisos,
});
